import React, { useCallback, useEffect, useState } from 'react'
import { useApp } from '../../../context/AppProvider'
import { constructUrl, filterBlockByType, isEmpty } from '../../../services/common'
import { icon } from '../../../services/icon'
import { Parser } from '../../common'
import UpdateButton from '../what-is-your-situation/UpdateButton'

const Problematics = ({ block = {} }) => {
    const {
        constructAffectTrueValue,
        setSelectedValue,
        selectedValue,
        validateSelection,
        attributesGuidedResearch,
        setHelpModal,
        identifier,
        setValidateSelection,
        type,
    } = useApp()

    const [displayConfirmSelectedSituation, setDisplayConfirmSelectedSituation] = useState(false)
    const [childrens, setChildrens] = useState([])
    const [urlHash, setUrlHash] = useState(null)

    const updateUrlHash = useCallback(() => {
        const currentHash = window.location.hash.substring(1)
        if (currentHash !== urlHash) {
            setUrlHash(currentHash)
            if (currentHash?.split('_').length < urlHash?.split('_').length) {
                setSelectedValue((prev) => prev.slice(0, -1))
            } else if (currentHash === '') {
                setSelectedValue([])
            }
        }
    }, [urlHash, setSelectedValue])

    useEffect(() => {
        const interval = setInterval(updateUrlHash, 100)
        return () => clearInterval(interval)
    }, [updateUrlHash])

    const blocksToParse = useCallback(
        (url) => {
            let currentChildren = block.childrens

            if (!url) return currentChildren
            const indices = url.split('_').map(Number)
            indices?.forEach((index) => {
                if (currentChildren && currentChildren[index]) {
                    const affectTrue = constructAffectTrueValue(currentChildren[index])
                    currentChildren = currentChildren[index].childrens

                    const label = filterBlockByType(currentChildren, 'Titre')?.content
                    const linkInternal = filterBlockByType(currentChildren, 'LienInterne')
                    const helpBlock = filterBlockByType(currentChildren, 'Aide')

                    setSelectedValue((prev) => {
                        if (prev.some((item) => item.label === label)) {
                            return prev
                        } else {
                            return [...prev, { affectTrue, helpBlock, linkInternal, label }]
                        }
                    })

                    const hasBranch = currentChildren.some((item) => item.block === 'Branche')
                    if (!hasBranch && type === 'Recherche guidée') setValidateSelection(true)
                    if (!hasBranch && type !== 'Recherche guidée') {
                        setDisplayConfirmSelectedSituation(true)
                    }
                }
            })

            return currentChildren
        },
        [block, urlHash, constructAffectTrueValue, setSelectedValue, type, setValidateSelection]
    )

    useEffect(() => {
        if (type) {
            const hash = window.location.hash.substring(1)
            const url = type === 'Recherche guidée' ? hash.split('?')[0] : urlHash
            setUrlHash(url)
            setChildrens(blocksToParse(url))
        }
    }, [blocksToParse, type])

    const onSubmit = (e) => {
        e.preventDefault()
        const lastSelectedValue = selectedValue[selectedValue.length - 1]
        const { LienPublication } = lastSelectedValue.linkInternal.attributes
        const { ID, audience } = attributesGuidedResearch
        const url =
            constructUrl(ID, audience) +
            '#' +
            urlHash +
            '?idFicheParent=' +
            identifier +
            '#' +
            urlHash +
            '&Fiche=' +
            LienPublication

        window.location.href = url
    }

    const onClickUpdatedSelection = useCallback(
        (e, index) => {
            e.preventDefault()
            const indices = urlHash.split('_').map(Number)
            const updatedIndices = indices.slice(0, index)
            const newHash = updatedIndices.join('_')
            window.location.hash = newHash
            setUrlHash(newHash)
            setSelectedValue((prev) => prev.slice(0, index))
            setDisplayConfirmSelectedSituation(false)
        },
        [urlHash, setUrlHash, setSelectedValue, setDisplayConfirmSelectedSituation]
    )
    return (
        <div className="baseocom-block-problematics">
            <form onSubmit={onSubmit}>
                {!isEmpty(selectedValue) &&
                    selectedValue.map((value, index) => (
                        <div key={index} className="baseocom-block-problematics-selected">
                            <p>
                                <span className="baseocom-block-problematics-selected-icon">
                                    {icon('checkbox-circle')}
                                </span>
                                {value.label}
                                {value?.helpBlock && (
                                    <button
                                        onClick={() => setHelpModal(value?.helpBlock)}
                                        type="button"
                                        className="baseocom-btn-help-modal"
                                    >
                                        {icon('help')}
                                    </button>
                                )}
                            </p>
                            {!validateSelection && (
                                <UpdateButton
                                    updateFunction={onClickUpdatedSelection}
                                    value={index}
                                />
                            )}
                        </div>
                    ))}
                <Parser content_block={childrens} type="research-guide" />
                {displayConfirmSelectedSituation && (
                    <div className="baseocom-problematics-btn-submit ">
                        <button type="submit">Afficher les informations</button>
                    </div>
                )}
            </form>
        </div>
    )
}

export default Problematics
